import ApplicationAdapter from './application';

export default class Comment extends ApplicationAdapter {
  modelNamePlural = 'comments';
}
